export default function Intro({ fade }: { fade: boolean }) {
  return (
    <div className={`intro ${fade ? "intro-hide" : ""}`}>
      <div className="intro-left"></div>
      <div className="intro-right"></div>
      <div className="intro-top"></div>
      <div className="intro-bottom"></div>

      <div className="intro-logo">
        <img src="/hob_logo.png" alt="logo" />
      </div>
    </div>
  );
}
